import React from 'react';
import { Modal } from 'antd';

export const DeleteScheduleModal = ({
    open,
    onCancel,
    onOk,
    loading,
    scheduleForDelete,
}) => {
    return (
        <Modal
            maskClosable={false}
            title="Delete Schedule"
            open={open}
            onCancel={onCancel}
            onOk={onOk}
            okText="Delete"
            okButtonProps={{ danger: true }}
            cancelText="Cancel"
            confirmLoading={loading}
            zIndex={1100}
        >
            {scheduleForDelete && (
                <p>
                    Are you sure you want to delete the schedule <strong>{scheduleForDelete.title}</strong>?
                    This will soft-delete the schedule group and cascade-remove all employee assignments for this group.
                </p>
            )}
        </Modal>
    );
};

export default DeleteScheduleModal;
